__webpack_require__.p = "https://bundle.stayforlong.com/20251219.2/_next/";